import { gql } from '@apollo/client/core'
import { myKudosFragment } from '/@/common/kudos/fragments'

export const vendorFragment = gql`
  fragment VendorFields on Vendor {
    id
    name
    isVerified
    affiliate
  }
`

export const productFragment = gql`
  ${myKudosFragment}
  ${vendorFragment}
  fragment ProductFields on Product {
    id
    thingType
    name
    description
    minPrice
    minPriceCent
    maxPrice
    maxPriceCent
    minWidthInches
    minHeightInches
    minDepthInches
    category {
      id
      key
      name
    }
    images {
      id
      url
      angle
      mediaGroupId
    }
    skus {
      id
      vendorUrl
      cleanVendorUrl
      price
      priceCent
      imageId
      mediaGroupId
      widthInches
      heightInches
      depthInches
      properties {
        id
        name
        value
      }
      sourceId
    }
    vendor {
      ...VendorFields
    }
    vendorUrl
    cleanVendorUrl
    bookmarkInfo {
      id
    }
    addedByDesignerId
    addedBy {
      id
      firstName
      lastName
      imageUrl
      nickname
    }
    myKudos {
      ...MyKudosProps
    }
    allKudos {
      count
    }
    editable
    isVerified
    sourceId
  }
`
